import React from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { endOfMonth, getMonth, setDate, setMonth, startOfMonth } from 'date-fns'
import is, { isNot } from 'typescript-styled-is'
import { IWithSize } from '../../Calendar/Calendar'
import styled, { ITheme } from '../../../../theme'

const Month = styled.div<
  IWithSize & { selected?: boolean; disabled?: boolean }
>`
  border-radius: 3px;
  display: flex;
  color: #272727;
  font-size: ${({ size }) => (size ? 1 * size : 1)}em;
  min-height: ${({ size }) => (size ? 2.25 * size : 2.25)}em;
  min-width: ${({ size }) => (size ? 2.25 * size : 2.25)}em;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border: 1px solid transparent;
  padding: ${({ size }) => (size ? 5 * size : 5)}px;
  margin: ${({ size }) => (size ? 3 * size : 3)}px;

  &:hover {
    ${isNot('selected', 'disabled')`
      color: ${(props: ITheme) => props.theme.colors.palette.emerald};
      border: 1px solid ${(props: ITheme) =>
        props.theme.colors.palette.emerald};
      `};
    cursor: pointer;
  }

  ${is('selected')`
		color: white;
		background-color: ${(props: ITheme) => props.theme.colors.palette.emerald}
	`}

  ${is('disabled')`
     pointer-events: none;
     color: ${(props: ITheme) => props.theme.colors.palette.greyish};
  `}
`

function MonthPicker({ size, startDate, toDay, minDate, maxDate }) {
  const { t } = useTranslation()
  const months = Array.from(new Array(12), (x, i) => `month_${i}`)

  function selectMonth(index) {
    return function() {
      toDay()(startOfMonth(setMonth(startDate, index)))
    }
  }

  function available(index) {
    return !(
      (minDate &&
        setDate(setMonth(startDate, index), 1) < setDate(minDate, 1)) ||
      (maxDate && setDate(setMonth(startDate, index), 1) >= endOfMonth(maxDate))
    )
  }

  return (
    <Flex style={{ marginLeft: `${10 * size}px` }}>
      {months.map((month, index) => (
        <Month
          selected={getMonth(startDate) === index}
          onClick={available(index) ? selectMonth(index) : undefined}
          disabled={!available(index)}
          size={size}
        >
          {t(month).substring(0, 3)}
        </Month>
      ))}
    </Flex>
  )
}

export default MonthPicker
